"use client";
import { useCallback, useEffect, useRef } from 'react';

const useBeforeUnload = (when: boolean): void => {
  const isEnabled = useRef(when);

  // Keep ref updated
  useEffect(() => {
    isEnabled.current = when;
  }, [when]);

  const handleBeforeUnload = useCallback((event: BeforeUnloadEvent): void => {
    if (!isEnabled.current) return;

    event.preventDefault();
    event.returnValue = 'You have unsaved changes!';
  }, []);

  useEffect(() => {
    if (!when) return;

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [when, handleBeforeUnload]);
};

export default useBeforeUnload;